export const GET_CATEGORIES = "GET_CATEGORIES";
export const GET_SUB_CATEGORIES = "GET_SUB_CATEGORIES";
export const GET_SUB_CATEGORIES_DETAILS = "GET_SUB_CATEGORIES_DETAILS";
export const RESET_SUB_CATEGORIES_DETAILS = "RESET_SUB_CATEGORIES_DETAILS";
export const SET_CATEGORY_LIST_STATUS = "SET_CATEGORY_LIST_STATUS";
